export const BREADCRUMBLIST_ACTION = "BREADCRUMBLIST_ACTION"
export const MENU_ACTION = "MENU_ACTION"
export const REFRESH_MENU_GROUP_ACTION = "REFRESH_MENU_GROUP_ACTION"
export const REFRESH_MENU_ACTION = "REFRESH_MENU_ACTION"
export const ASSIGNED_MENU_ACTION = "ASSIGNED_MENU_ACTION"
export const OPENKEYS_ACTION = "OPENKEYS_ACTION"
export const SELECTKEYS_ACTION = "SELECTKEYS_ACTION"

export const breadCrumbListAction = (breadCrumbList) => {
  return {
    type: BREADCRUMBLIST_ACTION,
    payload: breadCrumbList
  };
};

export const menuAction = (menuGroupList, menuList) => {
  return {
    type: MENU_ACTION,
    payload: {
      menuGroupList: menuGroupList,
      menuList: menuList
    }
  };

};
export const refreshMenuGroupAction = (allMenuGroup) => {
  return {
    type: REFRESH_MENU_GROUP_ACTION,
    payload: {
      allMenuGroup: allMenuGroup,
    }
  };
};

export const refreshMenuAction = (allMenu) => {
  return {
    type: REFRESH_MENU_ACTION,
    payload: {
      allMenu: allMenu
    }
  };
};

export const assignedMenuAction = (assignedMenu) => {
  return {
    type : ASSIGNED_MENU_ACTION,
    payload: {
      assignedMenu: assignedMenu
    }
  }
}

export const openKeysAction = (openKeys) => {
  return {
    type : OPENKEYS_ACTION,
    payload: {
      openKeys: openKeys,
    }
  }
}

export const selectkeysAction = (selectKeys) => {
  return {
    type : SELECTKEYS_ACTION,
    payload: {
      selectKeys: selectKeys
    }
  }
}